import { jsx as o } from "react/jsx-runtime";
import a from "classnames";
import r from "./index.es575.js";
import { BodyText as m } from "./index.es487.js";
const s = "label", b = ({ color: l, children: t, testId: e = s }) => /* @__PURE__ */ o(
  "div",
  {
    className: a(r.label, r[`label--color-${l}`]),
    "data-testid": e,
    children: /* @__PURE__ */ o(m, { color: "primary", children: t })
  }
);
export {
  s as LABEL_DEFAULT_TESTID,
  b as Label
};
//# sourceMappingURL=index.es61.js.map
